'use client';

import { c as _c } from "react/compiler-runtime";
import analytics, { FeatureFlagKey } from 'product-analytics';
import { useEffect, useState } from 'react';
function useFeatureFlag(name, skipWhile) {
  const $ = _c(7);
  let t0;
  if ($[0] !== name || $[1] !== skipWhile) {
    t0 = !skipWhile?.() ? analytics.getFeatureFlag(name) : undefined;
    $[0] = name;
    $[1] = skipWhile;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [featureFlag, setFeatureFlag] = useState(t0);
  let t1;
  let t2;
  if ($[3] !== name || $[4] !== skipWhile) {
    t1 = () => {
      if (skipWhile?.()) {
        return;
      }
      return analytics.listenToFeatureFlag(name, setFeatureFlag);
    };
    t2 = [name, setFeatureFlag, skipWhile];
    $[3] = name;
    $[4] = skipWhile;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  return featureFlag;
}
export default useFeatureFlag;